import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-mt-sm" }
const _hoisted_2 = { class: "q-mt-sm" }
const _hoisted_3 = { class: "text-subtitle2" }
const _hoisted_4 = { class: "text-subtitle3" }
const _hoisted_5 = { class: "text-body2" }
const _hoisted_6 = { class: "text-body3" }
const _hoisted_7 = { class: "text-body2" }
const _hoisted_8 = { class: "text-body3" }

import { onMounted, ref, watch, nextTick } from 'vue';
  import { QInput, QSelect } from 'quasar';
  import { useCurrencyFormatter, useLoanAmountCalculator, useMonthlyPaymentCalculator } from 'src/functions';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Calculator',
  props: {
    popout: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const props = __props

  const calcType = ref<"monthly" | "loan">("monthly");
  const monthlyRepayment = ref<number | null>(null);
  const loanAmount = ref<number | null>(null);
  const apr = ref<number | null>(null);
  const term = ref<number | null>(null);
  const monthlyInput = ref<QInput | null>(null);
  const loanInput = ref<QInput | null>(null);
  const termInput = ref<QSelect | null>(null);
  const aprInput = ref<QInput | null>(null);

  const aprRules = [
    (val: number) => (!!val) || "Required!",
    (val: number) => (val > 0) || "Must be Greater than 0!",
    (val: number) => (val < 100) || "Must be Less than 100!"
  ];
  const monthlyRepaymentRules = [
    (val: number) => (!!val) || "Required!",
    (val: number) => (val >= 10) || "Must be Greater than 10!",
    (val: number) => (val <= 5000) || "Must be Less than 5000!"
  ];
  const loanAmountRules = [
    (val: number) => (!!val) || "Required!",
    (val: number) => (val >= 100) || "Must be Greater than 100!",
    (val: number) => (val <= 100000) || "Must be Less than 100000!"
  ];
  const termRules = [
    (val: number) => (!!val) || "Required!",
    (val: number) => (val >= 12) || "Must be at least 12 months!",
    (val: number) => (val <= 60) || "Must be less than 60 months!"
  ];
  const monthlyRepaymentDisplay = ref<number | null>(null);
  const loanAmountDisplay = ref<number | null>(null);
  const costOfCreditDisplay = ref<number | null>(null);
  const totalAmountDisplay = ref<number | null>(null);
  const showCalculations = ref(false);

  onMounted(async () => {
    monthlyRepayment.value = 250;
    loanAmount.value = 10000;
    apr.value = 9.9;
    term.value = 60;

    await nextTick();

    calculate();
  });

  watch([apr, term, monthlyRepayment, loanAmount], async () => {
    await nextTick();
    calculate();
  });

  const calculate = () => {
    let valid = true;
    aprInput.value!.validate() ? null : valid = false;
    termInput.value!.validate() ? null : valid = false;
    calcType.value === "monthly" ?
      (loanInput.value!.validate() ? null : valid = false) :
      (monthlyInput.value!.validate() ? null : valid = false);

    if (!valid) {
      if (calcType.value === "monthly") {
        monthlyRepaymentDisplay.value = 0;
        totalAmountDisplay.value = 0
        costOfCreditDisplay.value = 0;
        monthlyRepayment.value = 0
        loanAmountDisplay.value = loanAmount.value;
      }
      else {
        loanAmountDisplay.value = 0
        totalAmountDisplay.value = 0
        costOfCreditDisplay.value = 0
        loanAmount.value = 0
        monthlyRepaymentDisplay.value = 0
      }
    }
    else {
      if (calcType.value === "monthly") {
        monthlyRepaymentDisplay.value = useMonthlyPaymentCalculator(apr.value!, loanAmount.value!, term.value!);
        totalAmountDisplay.value = monthlyRepaymentDisplay.value * term.value!;
        costOfCreditDisplay.value = totalAmountDisplay.value - loanAmount.value!;
        monthlyRepayment.value = monthlyRepaymentDisplay.value;
        loanAmountDisplay.value = loanAmount.value;
      }
      else {
        loanAmountDisplay.value = useLoanAmountCalculator(apr.value!, monthlyRepayment.value!, term.value!);
        totalAmountDisplay.value = monthlyRepayment.value! * term.value!;
        costOfCreditDisplay.value = totalAmountDisplay.value - loanAmountDisplay.value!;
        loanAmount.value = loanAmountDisplay.value;
        monthlyRepaymentDisplay.value = monthlyRepayment.value;
      }
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { flat: __props.popout }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "text-h5 text-dark" }, "Quote Calculator", -1)
        ])),
        _: 1,
        __: [8]
      }),
      _createVNode(_component_q_card_section, { class: "q-pb-sm" }, {
        default: _withCtx(() => [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-overline text-uppercase" }, "calculate", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_radio, {
              modelValue: calcType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((calcType).value = $event)),
              val: "monthly",
              class: "text-body2",
              label: "Monthly Repayments",
              color: "black",
              dense: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_radio, {
              modelValue: calcType.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((calcType).value = $event)),
              val: "loan",
              class: "text-body2",
              label: "Loan Amount",
              color: "black",
              dense: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1,
        __: [9]
      }),
      _createVNode(_component_q_tab_panels, {
        modelValue: calcType.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((calcType).value = $event)),
        animated: "",
        class: "shadow-2 rounded-borders",
        "transition-prev": "fade",
        "transition-next": "fade"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, { name: "monthly" }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "text-overline text-uppercase q-mb-xs",
                "q-mb-xs": ""
              }, "Loan Amount", -1)),
              _createVNode(_unref(QInput), {
                modelValue: loanAmount.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loanAmount).value = $event)),
                ref_key: "loanInput",
                ref: loanInput,
                prefix: "£",
                class: "input-container",
                outlined: "",
                dense: "",
                color: "primary",
                rules: loanAmountRules
              }, null, 8, ["modelValue"])
            ]),
            _: 1,
            __: [10]
          }),
          _createVNode(_component_q_tab_panel, { name: "loan" }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("div", {
                class: "text-overline text-uppercase q-mb-xs",
                "q-mb-xs": ""
              }, "Monthly Repayment", -1)),
              _createVNode(_unref(QInput), {
                modelValue: monthlyRepayment.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((monthlyRepayment).value = $event)),
                ref_key: "monthlyInput",
                ref: monthlyInput,
                prefix: "£",
                class: "input-container",
                outlined: "",
                dense: "",
                color: "primary",
                rules: monthlyRepaymentRules
              }, null, 8, ["modelValue"])
            ]),
            _: 1,
            __: [11]
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_card_section, { class: "q-py-none" }, {
        default: _withCtx(() => [
          _cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "text-overline text-uppercase q-mb-xs",
            "q-mb-xs": ""
          }, "Term (Months)", -1)),
          _createVNode(_unref(QInput), {
            modelValue: term.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((term).value = $event)),
            modelModifiers: { number: true },
            ref_key: "termInput",
            ref: termInput,
            class: "input-container",
            type: "number",
            outlined: "",
            dense: "",
            color: "primary",
            rules: termRules,
            "hide-spin-buttons": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1,
        __: [12]
      }),
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "text-overline text-uppercase q-mb-xs",
            "q-mb-xs": ""
          }, "APR", -1)),
          _createVNode(_unref(QInput), {
            modelValue: apr.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((apr).value = $event)),
            modelModifiers: { number: true },
            ref_key: "aprInput",
            ref: aprInput,
            suffix: "%",
            class: "input-container",
            type: "number",
            outlined: "",
            dense: "",
            rules: aprRules,
            "hide-spin-buttons": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1,
        __: [13]
      }),
      _createVNode(_component_q_card_section, { class: "q-pb-xs" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panels, {
            modelValue: calcType.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((calcType).value = $event)),
            animated: "",
            class: "rounded-borders",
            "transition-prev": "fade",
            "transition-next": "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tab_panel, {
                name: "monthly",
                class: "q-px-none q-pt-none q-pb-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, { separator: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item, { style: {"padding-left":"0px","padding-right":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createElementVNode("span", { class: "text-subtitle2 text-dark" }, "Monthly Repayment", -1)
                            ])),
                            _: 1,
                            __: [14]
                          }),
                          _createVNode(_component_q_item_section, {
                            side: "",
                            class: "text-h6"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(monthlyRepaymentDisplay.value,2,2).split(".")[0]) + ".", 1),
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(useCurrencyFormatter)(monthlyRepaymentDisplay.value,2,2).split(".")[1]), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item, { style: {"padding-left":"0px","padding-right":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createElementVNode("span", { class: "text-body2" }, "Total Cost of Credit", -1)
                            ])),
                            _: 1,
                            __: [15]
                          }),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(costOfCreditDisplay.value,2,2).split(".")[0]) + ".", 1),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(useCurrencyFormatter)(costOfCreditDisplay.value,2,2).split(".")[1]), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item, { style: {"padding-left":"0px","padding-right":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createElementVNode("span", { class: "text-body2" }, "Total Payable", -1)
                            ])),
                            _: 1,
                            __: [16]
                          }),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(totalAmountDisplay.value,2,2).split(".")[0]) + ".", 1),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(useCurrencyFormatter)(totalAmountDisplay.value,2,2).split(".")[1]), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_tab_panel, {
                name: "loan",
                class: "q-px-none q-pt-none q-pb-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, {
                    separator: "",
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item, { style: {"padding-left":"0px","padding-right":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createElementVNode("span", { class: "text-subtitle2" }, "Loan Amount", -1)
                            ])),
                            _: 1,
                            __: [17]
                          }),
                          _createVNode(_component_q_item_section, {
                            side: "",
                            class: "text-h6"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(loanAmountDisplay.value,2,2)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item, { style: {"padding-left":"0px","padding-right":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createElementVNode("span", { class: "text-body2" }, "Total Cost of Credit", -1)
                            ])),
                            _: 1,
                            __: [18]
                          }),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(costOfCreditDisplay.value,2,2)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item, { style: {"padding-left":"0px","padding-right":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createElementVNode("span", { class: "text-body2" }, "Total Payable", -1)
                            ])),
                            _: 1,
                            __: [19]
                          }),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(totalAmountDisplay.value,2,2)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["flat"]))
}
}

})